import React from 'react'
import { compose } from 'recompose'
import CmsProductSlider from 'cms/CmsProductSlider'
import withProductSlider from '../../redux/product/withProductSlider'

const ProductSlider = compose(
  withProductSlider(),
)(
  ({
    products,
    style,
    assets: {
      defaultImage,
    },
    router,
    settings: {
      product: productSettings,
      slider: sliderSettings,
    },
    renderElement,
  }) => {
    return (
      renderElement(
        CmsProductSlider,
        {
          style,
          router,
          products,
          productSettings,
          sliderSettings,
          defaultImage,
        }
      )
    )
  }
)

ProductSlider.propTypes = {}
ProductSlider.defaultProps = {}

export default ProductSlider



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/productSlider/ProductSlider.js